module.exports = __webpack_public_path__ + "img/instagram--white.f6e77b59.svg";